export default class CarriageTabs {
  static init(node) {
    if (!node) {
      return null;
    }
    return new CarriageTabs(node);
  }

  constructor(node) {
    this.selectors = {
      tabBtnSelector: '[data-smart-apartment-tab-button]',
      carriageSelector: '[data-smart-apartment-tabs-panel-carriage]',
    };

    this.els = {
      tabsContainer: node,
      tabs: [...node.querySelectorAll(this.selectors.tabBtnSelector)],
      carriage: node.querySelector(this.selectors.carriageSelector),
    };

    const { tabs } = this.els;

    // NOTE: by default
    this.activeTabIndex = '1';
    this.currentTab = tabs[0];

    this.addEventListeners();
    this.setCarriagePosition(this.currentTab);
  }

  UpdateActiveClassName() {
    const { tabsContainer } = this.els;

    this.activeTabIndex = tabsContainer
      .closest('section')
      .getAttribute('data-active');
  }

  getCurrentTab() {
    const { tabs } = this.els;

    tabs.forEach((currentTab) => {
      if (currentTab.getAttribute('data-active-tab') === this.activeTabIndex) {
        this.currentTab = currentTab;
      }
    });
  }

  setCarriagePosition(tab) {
    const { carriage } = this.els;
    const tabOffsetLeft = tab.offsetLeft;
    const tabWidth = tab.offsetWidth;

    carriage.style.left = `${tabOffsetLeft}px`;
    carriage.style.width = `${tabWidth}px`;
  }

  addEventListeners() {
    const { tabBtnSelector } = this.selectors;
    const { tabsContainer } = this.els;

    tabsContainer.addEventListener('click', (event) => {
      event.preventDefault();
      const tab = event.target.closest(tabBtnSelector);

      if (tab) {
        this.setCarriagePosition(tab);
        this.currentTab = tab;
      }
    });

    window.addEventListener('resize', () => {
      this.UpdateActiveClassName();
      this.getCurrentTab();
      this.setCarriagePosition(this.currentTab);
    });
  }
}
